import { runStorageMigration } from '~/utility/storageMigration';

export default defineNuxtPlugin(() => {
  runStorageMigration();
});